import { DomainsChipDownContainer } from "@similarweb/ui-components";
import { ListItemWebsite } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const DomainsFilter = (props) => {
    const t = useTranslation();
    const { onDomainFilterChange, selectedDomain, domains } = props;
    const selectedDomainObject = domains.find((x) => x.name === selectedDomain) || domains[0];

    return (
        <DomainsChipDownContainer
            onClick={onDomainFilterChange}
            selectedIds={{ [selectedDomainObject.name]: true }}
            selectedDomainText={selectedDomainObject.displayName}
            selectedDomainIcon={selectedDomainObject.icon}
            onCloseItem={() => onDomainFilterChange(null)}
            buttonText={null}
            noResultsMessage={t("dropdown.no.results")}
        >
            {domains.map((item, index) => {
                const { name, icon } = item;
                return (
                    <ListItemWebsite
                        key={index}
                        text={name}
                        img={icon}
                    />
                );
            })}
        </DomainsChipDownContainer>
    );
};
